/**
 * AST 기반 자동 생성된 검증 함수
 * 이 파일은 scripts/generate-validators.ts에 의해 자동 생성됩니다.
 * 수동으로 수정하지 마세요.
 * 
 * 생성 시간: 2026-09-18T08:13:01.414Z
 * 소스 파일: src/data/dto/patient-treatement-detail-list/patient-treatment-list-reponse-dto
 */

import type { PatientTreatmentListResponseDto } from "@/data/dto/patient-treatement-detail-list/patient-treatment-list-reponse-dto";

/**
 * PatientTreatmentListResponseDto 타입 가드 함수
 * AST 분석을 통해 자동 생성된 최적화된 검증 함수
 */
export function isPatientTreatmentListResponseDto(input: unknown): input is PatientTreatmentListResponseDto {
  if (typeof input !== "object" || input === null || Array.isArray(input)) {
    return false;
  }
  
  const obj = input as Record<string, unknown>;
  
  return (
    typeof obj.patient === "object" && obj.patient !== null && !Array.isArray(obj.patient) &&
typeof (obj.patient as any).screeningId === "string" &&
((obj.patient as any).fullName === undefined || ((obj.patient as any).fullName == null || typeof (obj.patient as any).fullName === "string")) &&
((obj.patient as any).lastName === undefined || ((obj.patient as any).lastName == null || typeof (obj.patient as any).lastName === "string")) &&
((obj.patient as any).firstName === undefined || ((obj.patient as any).firstName == null || typeof (obj.patient as any).firstName === "string")) &&
((obj.patient as any).birthDate === undefined || typeof (obj.patient as any).birthDate === "string") &&
((obj.patient as any).gender === undefined || ((obj.patient as any).gender == null || typeof (obj.patient as any).gender === "string")) &&
((obj.patient as any).memo === undefined || ((obj.patient as any).memo == null || typeof (obj.patient as any).memo === "string")) &&
typeof (obj.patient as any).isDeactivated === "boolean" &&
    (obj.guardian === undefined || true) &&
    typeof obj.currTreatmentStep === "number" && !isNaN(obj.currTreatmentStep) &&
    typeof obj.currTreatmentState === "string" &&
    typeof obj.sumActuallyPlayTime === "number" && !isNaN(obj.sumActuallyPlayTime) &&
    typeof obj.sumRecommendedTotalPlayTime === "number" && !isNaN(obj.sumRecommendedTotalPlayTime) &&
    typeof obj.isInVisitDate === "boolean" &&
    typeof obj.isAccountExisting === "boolean" &&
    Array.isArray(obj.treatmentInfoList) && obj.treatmentInfoList.every((item) => typeof item === "object" && item !== null && !Array.isArray(item) &&
typeof (item as any).treatmentInfoUuid === "string" &&
  typeof (item as any).step === "number" && !isNaN((item as any).step) &&
typeof (item as any).state === "string" &&
typeof (item as any).startDate === "string" &&
typeof (item as any).endDate === "string" &&
  typeof (item as any).actuallyExecutedDay === "number" && !isNaN((item as any).actuallyExecutedDay) &&
  typeof (item as any).recommendedExecutedDay === "number" && !isNaN((item as any).recommendedExecutedDay) &&
  typeof (item as any).actuallyPlayTime === "number" && !isNaN((item as any).actuallyPlayTime) &&
  typeof (item as any).recommendedTotalPlayTime === "number" && !isNaN((item as any).recommendedTotalPlayTime) &&
typeof (item as any).doctorName === "string" && (item as any).doctorName.trim() !== "") &&
    (obj.voucher === undefined || true)
  );
}

/**
 * PatientTreatmentListResponseDto 상세 검증 결과 반환 함수
 * 검증 실패 시 상세한 에러 정보를 반환합니다.
 */
export interface IValidation<T> {
  success: boolean;
  data?: T;
  errors?: Array<{ path: string; expected: string; value: unknown }>;
}

export function validatePatientTreatmentListResponseDto(input: unknown): IValidation<PatientTreatmentListResponseDto> {
  const errors: Array<{ path: string; expected: string; value: unknown }> = [];
  
  if (typeof input !== "object" || input === null || Array.isArray(input)) {
    errors.push({
      path: "",
      expected: "object",
      value: input,
    });
    return {
      success: false,
      errors,
    };
  }
  
  const obj = input as Record<string, unknown>;
  
    if (typeof obj !== "object" || obj === null || Array.isArray(obj)) {
      errors.push({ path: "", expected: "object", value: obj });
    } else {
      const objObj = obj as Record<string, unknown>;
      // patient (required)
      if (objObj.patient === undefined) {
        errors.push({ path: "patient", expected: "object", value: undefined });
      } else {
        if (typeof objObj.patient !== "object" || objObj.patient === null || Array.isArray(objObj.patient)) {
          errors.push({ path: "patient", expected: "object", value: objObj.patient });
        } else {
          const objObj_patientObj = objObj.patient as Record<string, unknown>;
          // screeningId (required)
          if (objObj_patientObj.screeningId === undefined) {
            errors.push({ path: "patient.screeningId", expected: "string", value: undefined });
          } else {
            if (typeof objObj_patientObj.screeningId !== "string") {
              errors.push({ path: "patient.screeningId", expected: "string", value: objObj_patientObj.screeningId });
            }
          }
          // fullName (optional)
          if (objObj_patientObj.fullName !== undefined) {
            if (!(objObj_patientObj.fullName == null || typeof objObj_patientObj.fullName === "string")) {
              errors.push({ path: "patient.fullName", expected: "string | null", value: objObj_patientObj.fullName });
            }
          }
          // lastName (optional)
          if (objObj_patientObj.lastName !== undefined) {
            if (!(objObj_patientObj.lastName == null || typeof objObj_patientObj.lastName === "string")) {
              errors.push({ path: "patient.lastName", expected: "string | null", value: objObj_patientObj.lastName });
            }
          }
          // firstName (optional)
          if (objObj_patientObj.firstName !== undefined) {
            if (!(objObj_patientObj.firstName == null || typeof objObj_patientObj.firstName === "string")) {
              errors.push({ path: "patient.firstName", expected: "string | null", value: objObj_patientObj.firstName });
            }
          }
          // birthDate (optional)
          if (objObj_patientObj.birthDate !== undefined) {
            if (typeof objObj_patientObj.birthDate !== "string") {
              errors.push({ path: "patient.birthDate", expected: "string", value: objObj_patientObj.birthDate });
            }
          }
          // gender (optional)
          if (objObj_patientObj.gender !== undefined) {
            if (!(objObj_patientObj.gender == null || typeof objObj_patientObj.gender === "string")) {
              errors.push({ path: "patient.gender", expected: "string | null", value: objObj_patientObj.gender });
            }
          }
          // memo (optional)
          if (objObj_patientObj.memo !== undefined) {
            if (!(objObj_patientObj.memo == null || typeof objObj_patientObj.memo === "string")) {
              errors.push({ path: "patient.memo", expected: "string | null", value: objObj_patientObj.memo });
            }
          }
          // isDeactivated (required)
          if (objObj_patientObj.isDeactivated === undefined) {
            errors.push({ path: "patient.isDeactivated", expected: "boolean", value: undefined });
          } else {
            if (typeof objObj_patientObj.isDeactivated !== "boolean") {
              errors.push({ path: "patient.isDeactivated", expected: "boolean", value: objObj_patientObj.isDeactivated });
            }
          }
        }
      }
      // guardian (optional)
      if (objObj.guardian !== undefined) {
      
      }
      // currTreatmentStep (required)
      if (objObj.currTreatmentStep === undefined) {
        errors.push({ path: "currTreatmentStep", expected: "number", value: undefined });
      } else {
        if (!(typeof objObj.currTreatmentStep === "number" && !isNaN(objObj.currTreatmentStep))) {
          errors.push({ path: "currTreatmentStep", expected: "number", value: objObj.currTreatmentStep });
        }
      }
      // currTreatmentState (required)
      if (objObj.currTreatmentState === undefined) {
        errors.push({ path: "currTreatmentState", expected: "string", value: undefined });
      } else {
        if (typeof objObj.currTreatmentState !== "string") {
          errors.push({ path: "currTreatmentState", expected: "string", value: objObj.currTreatmentState });
        }
      }
      // sumActuallyPlayTime (required)
      if (objObj.sumActuallyPlayTime === undefined) {
        errors.push({ path: "sumActuallyPlayTime", expected: "number", value: undefined });
      } else {
        if (!(typeof objObj.sumActuallyPlayTime === "number" && !isNaN(objObj.sumActuallyPlayTime))) {
          errors.push({ path: "sumActuallyPlayTime", expected: "number", value: objObj.sumActuallyPlayTime });
        }
      }
      // sumRecommendedTotalPlayTime (required)
      if (objObj.sumRecommendedTotalPlayTime === undefined) {
        errors.push({ path: "sumRecommendedTotalPlayTime", expected: "number", value: undefined });
      } else {
        if (!(typeof objObj.sumRecommendedTotalPlayTime === "number" && !isNaN(objObj.sumRecommendedTotalPlayTime))) {
          errors.push({ path: "sumRecommendedTotalPlayTime", expected: "number", value: objObj.sumRecommendedTotalPlayTime });
        }
      }
      // isInVisitDate (required)
      if (objObj.isInVisitDate === undefined) {
        errors.push({ path: "isInVisitDate", expected: "boolean", value: undefined });
      } else {
        if (typeof objObj.isInVisitDate !== "boolean") {
          errors.push({ path: "isInVisitDate", expected: "boolean", value: objObj.isInVisitDate });
        }
      }
      // isAccountExisting (required)
      if (objObj.isAccountExisting === undefined) {
        errors.push({ path: "isAccountExisting", expected: "boolean", value: undefined });
      } else {
        if (typeof objObj.isAccountExisting !== "boolean") {
          errors.push({ path: "isAccountExisting", expected: "boolean", value: objObj.isAccountExisting });
        }
      }
      // treatmentInfoList (required)
      if (objObj.treatmentInfoList === undefined) {
        errors.push({ path: "treatmentInfoList", expected: "array", value: undefined });
      } else {
        if (!Array.isArray(objObj.treatmentInfoList)) {
          errors.push({ path: "treatmentInfoList", expected: "array", value: objObj.treatmentInfoList });
        } else {
          objObj.treatmentInfoList.forEach((item, idx) => {
              if (typeof item !== "object" || item === null || Array.isArray(item)) {
          errors.push({ path: "treatmentInfoList[idx]", expected: "object", value: item });
        } else {
          const itemObj = item as Record<string, unknown>;
          // treatmentInfoUuid (required)
          if (itemObj.treatmentInfoUuid === undefined) {
            errors.push({ path: "treatmentInfoList[idx].treatmentInfoUuid", expected: "string", value: undefined });
          } else {
            if (typeof itemObj.treatmentInfoUuid !== "string") {
              errors.push({ path: "treatmentInfoList[idx].treatmentInfoUuid", expected: "string", value: itemObj.treatmentInfoUuid });
            }
          }
          // step (required)
          if (itemObj.step === undefined) {
            errors.push({ path: "treatmentInfoList[idx].step", expected: "number", value: undefined });
          } else {
            if (!(typeof itemObj.step === "number" && !isNaN(itemObj.step))) {
              errors.push({ path: "treatmentInfoList[idx].step", expected: "number", value: itemObj.step });
            }
          }
          // state (required)
          if (itemObj.state === undefined) {
            errors.push({ path: "treatmentInfoList[idx].state", expected: "string", value: undefined });
          } else {
            if (typeof itemObj.state !== "string") {
              errors.push({ path: "treatmentInfoList[idx].state", expected: "string", value: itemObj.state });
            }
          }
          // startDate (required)
          if (itemObj.startDate === undefined) {
            errors.push({ path: "treatmentInfoList[idx].startDate", expected: "string", value: undefined });
          } else {
            if (typeof itemObj.startDate !== "string") {
              errors.push({ path: "treatmentInfoList[idx].startDate", expected: "string", value: itemObj.startDate });
            }
          }
          // endDate (required)
          if (itemObj.endDate === undefined) {
            errors.push({ path: "treatmentInfoList[idx].endDate", expected: "string", value: undefined });
          } else {
            if (typeof itemObj.endDate !== "string") {
              errors.push({ path: "treatmentInfoList[idx].endDate", expected: "string", value: itemObj.endDate });
            }
          }
          // actuallyExecutedDay (required)
          if (itemObj.actuallyExecutedDay === undefined) {
            errors.push({ path: "treatmentInfoList[idx].actuallyExecutedDay", expected: "number", value: undefined });
          } else {
            if (!(typeof itemObj.actuallyExecutedDay === "number" && !isNaN(itemObj.actuallyExecutedDay))) {
              errors.push({ path: "treatmentInfoList[idx].actuallyExecutedDay", expected: "number", value: itemObj.actuallyExecutedDay });
            }
          }
          // recommendedExecutedDay (required)
          if (itemObj.recommendedExecutedDay === undefined) {
            errors.push({ path: "treatmentInfoList[idx].recommendedExecutedDay", expected: "number", value: undefined });
          } else {
            if (!(typeof itemObj.recommendedExecutedDay === "number" && !isNaN(itemObj.recommendedExecutedDay))) {
              errors.push({ path: "treatmentInfoList[idx].recommendedExecutedDay", expected: "number", value: itemObj.recommendedExecutedDay });
            }
          }
          // actuallyPlayTime (required)
          if (itemObj.actuallyPlayTime === undefined) {
            errors.push({ path: "treatmentInfoList[idx].actuallyPlayTime", expected: "number", value: undefined });
          } else {
            if (!(typeof itemObj.actuallyPlayTime === "number" && !isNaN(itemObj.actuallyPlayTime))) {
              errors.push({ path: "treatmentInfoList[idx].actuallyPlayTime", expected: "number", value: itemObj.actuallyPlayTime });
            }
          }
          // recommendedTotalPlayTime (required)
          if (itemObj.recommendedTotalPlayTime === undefined) {
            errors.push({ path: "treatmentInfoList[idx].recommendedTotalPlayTime", expected: "number", value: undefined });
          } else {
            if (!(typeof itemObj.recommendedTotalPlayTime === "number" && !isNaN(itemObj.recommendedTotalPlayTime))) {
              errors.push({ path: "treatmentInfoList[idx].recommendedTotalPlayTime", expected: "number", value: itemObj.recommendedTotalPlayTime });
            }
          }
          // doctorName (required)
          if (itemObj.doctorName === undefined) {
            errors.push({ path: "treatmentInfoList[idx].doctorName", expected: "string", value: undefined });
          } else {
            if (!(typeof itemObj.doctorName === "string" && itemObj.doctorName.trim() !== "")) {
              errors.push({ path: "treatmentInfoList[idx].doctorName", expected: "string (non-empty)", value: itemObj.doctorName });
            }
          }
        }
          });
        }
      }
      // voucher (optional)
      if (objObj.voucher !== undefined) {
      
      }
    }
  
  if (errors.length === 0 && isPatientTreatmentListResponseDto(input)) {
    return {
      success: true,
      data: input,
    };
  }
  
  return {
    success: false,
    errors: errors.length > 0 ? errors : [
      {
        path: "",
        expected: "PatientTreatmentListResponseDto",
        value: input,
      },
    ],
  };
}

/**
 * PatientTreatmentListResponseDto 검증 후 에러 throw 함수
 * 검증 실패 시 상세한 에러 정보를 포함하여 에러를 throw합니다.
 */
export function assertPatientTreatmentListResponseDto(input: unknown): PatientTreatmentListResponseDto {
  const validation = validatePatientTreatmentListResponseDto(input);
  if (!validation.success) {
    const errorDetails = validation.errors?.map(err => 
      `  - ${err.path}: 예상 타입 ${err.expected}, 실제 값: ${JSON.stringify(err.value)}`
    ).join("\n") || "알 수 없는 오류";
    throw new Error(`[assertPatientTreatmentListResponseDto] :: 검증 실패: PatientTreatmentListResponseDto 타입과 일치하지 않습니다\n\n오류 상세:\n${errorDetails}`);
  }
  return validation.data!;
}
